var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"img-wrapper"},[_c('img',{attrs:{"src":_vm.Loading}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }